import React, { useState } from 'react';
import { useAppState, AppProvider } from './hooks/useAppState';
import { CardPaymentModalProvider } from './hooks/useCardPaymentModal';
import { getConfig } from './services/configManager';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import TicketSummaryPage from './pages/TicketSummaryPage';
import MemberRegistrationPage from './pages/MemberRegistrationPage';
import GuestRegistrationPage from './pages/GuestRegistrationPage';
import MemberThankYouPage from './pages/MemberThankYouPage';
import GuestThankYouPage from './pages/GuestThankYouPage';
import TicketVoidWaitingPage from './pages/TicketVoidWaitingPage';
import ContactUsPage from './pages/ContactUsPage';
import ErrorModal from './components/ErrorModal';
import LoadingSpinner from './components/LoadingSpinner';
import SplashScreen from './components/SplashScreen';
import './App.css';


function AppContent() {
  const { state, setError } = useAppState();
  const [showSplash, setShowSplash] = useState(getConfig().SPLASH_SCREEN.ENABLED);
  
  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  const renderCurrentPage = () => {
    
    switch (state.currentStep) {
      case 'home':
        return <HomePage />;
      case 'ticket-summary':
        return <TicketSummaryPage />;
      case 'member-registration':
        return <MemberRegistrationPage />;
      case 'guest-registration':
        return <GuestRegistrationPage />;
      case 'ticket-void-waiting':
        return <TicketVoidWaitingPage />;
      case 'member-thank-you':
        return <MemberThankYouPage />;
      case 'guest-thank-you':
        return <GuestThankYouPage />;
      case 'contact-us':
        return <ContactUsPage />;
      default:
        return <HomePage />;
    }
  };

  // Show splash screen on first load if enabled
  if (showSplash) {
    return (
      <SplashScreen 
        onComplete={handleSplashComplete} 
        duration={getConfig().SPLASH_SCREEN.DURATION}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gray-bg flex flex-col">
      <Header />
      
      <main className="flex-1 flex flex-col">
        {state.isLoading && <LoadingSpinner />}
        {renderCurrentPage()}
      </main>
      
      <Footer />
      
      {state.error && (
        <ErrorModal 
          message={state.error} 
          validationErrors={state.validationErrors}
          onClose={() => setError(null)} 
        />
      )}
    </div>
  );
}

function App() {
  return (
    <AppProvider>
      <CardPaymentModalProvider>
        <AppContent />
      </CardPaymentModalProvider>
    </AppProvider>
  );
}

export default App;
